import { ImportFileButton } from '@components/common/inputs/buttons/ImportFileButton';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectActiveSite } from '@redux/authent/authent.selectors';
import { useImportPerimetersCameraMutation, useImportSensorConfigurationsMutation } from '@services/c2/c2.api';
import { importJsonFile } from '@utils/importExport.utils';
import { ChangeEvent } from 'react';

export const SensorConfigurationsImportButton = () => {
  const activeSite = useAppSelector(selectActiveSite);
  const [importSensorConfigurations, { isLoading }] = useImportSensorConfigurationsMutation();

  const handleSensorsJsonImport = async (event: ChangeEvent<HTMLInputElement>) => {
    if (activeSite?.code) {
      await importJsonFile(
        event,
        activeSite.code,
        importSensorConfigurations,
        'components.sensorInstallation.importSensorsSuccess',
      );
    }
  };

  return (
    <ImportFileButton
      label="components.sensorInstallation.importSensors"
      isLoading={isLoading}
      onFileChange={handleSensorsJsonImport}
    />
  );
};

export const PerimeterCamerasImportButton = () => {
  const activeSite = useAppSelector(selectActiveSite);
  const [importPerimeterCameras, { isLoading }] = useImportPerimetersCameraMutation();

  const handlePerimeterCamerasImport = async (event: ChangeEvent<HTMLInputElement>) => {
    if (activeSite?.code) {
      await importJsonFile(
        event,
        activeSite.code,
        importPerimeterCameras,
        'components.sensorInstallation.importPerimeterCamerasSuccess',
      );
    }
  };

  return (
    <ImportFileButton
      label="components.sensorInstallation.importPerimeterCameras"
      isLoading={isLoading}
      onFileChange={handlePerimeterCamerasImport}
    />
  );
};
